import Presets, { type PresetsType } from '@assets/hdri';
import { KEY } from '@constants/key';
import { useLocalization } from '@lib/localization';
import { CardContent, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import { useAppSelector } from '@store/hooks';
import { defaultRoomEnv, setRoomEnvironment } from '@store/reducers/viewerSlice';
import { useDispatch } from 'react-redux';
import { CardDescription, CardHeader, CardTitle } from './Settings.styled';

const ViewerEnvironmentCard = () => {
  const dispatch = useDispatch();
  const { roomEnvironment } = useAppSelector(state => state.viewer);
  const { t } = useLocalization();

  const handleChangeEnvironment = (val: string) => {
    const type = val as PresetsType;

    localStorage.setItem(KEY.ROOM_ENV, type);
    dispatch(setRoomEnvironment(type));
  };

  return (
    <Paper sx={{ mb: 2 }}>
      <CardHeader>
        <CardTitle variant="h6">{t('Settings_ViewerRoomEnv')}</CardTitle>
        <CardDescription variant="body2">{t('Settings_ViewerRoomEnv_Subtitle')}</CardDescription>
      </CardHeader>
      <CardContent style={{ padding: '24px' }}>
        <FormControl fullWidth size="small">
          <InputLabel id="environment-select-label">{t('Settings_ViewerRoomEnv_Select')}</InputLabel>
          <Select
            labelId="environment-select-label"
            value={roomEnvironment}
            onChange={(val) => { handleChangeEnvironment(val.target.value); }}
            label={t('Settings_ViewerRoomEnv_Select')}
          >
            {Object.entries(Presets)
              .map(([key, _v]) => (
                <MenuItem key={key} value={key}>
                  {`${t(`Settings_ViewerRoomEnv_${key.capitalize()}`)}${key === defaultRoomEnv
                    ? ` (${t('Common_Default')})`
                    : ''}`
                  }
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </CardContent>
    </Paper>
  );
};

export default ViewerEnvironmentCard;
